import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/tickets/$ticketId")({
  head: () => ({ meta: [{ title: "Ticket | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-tickets-ticketId")),
});
